import React from 'react';
import {MAP_SERVICE_TYPE} from "../../constants";

const PendingServiceDetailsSideBar = ({serviceDetails}) => {
    return (
        <React.Fragment>
            <img src="/images/pending-mobile-connection.jpg" alt="Pending connection" className='d-none d-md-block'/>
            <div className="inner">
                <h3 className="m-0 mb-3 bold">{serviceDetails.type === 'sim' ? 'Replacement SIM' : 'New mobile service'}</h3>
                <ul className="m-0 p-0">
                    <li>Service number - {serviceDetails.serviceNo}</li>
                    <li>Service type - {MAP_SERVICE_TYPE[serviceDetails.type]}</li>
                    <li>Plan name - {serviceDetails.planName}</li>
                    <li>Data - {serviceDetails.data}</li>
                </ul>
            </div>
        </React.Fragment>
    )
}

export default PendingServiceDetailsSideBar;



// WEBPACK FOOTER //
// ./resources/js/modules/PendingConnection/PendingServiceDetailsSideBar.js